import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../web/components-v2/Theme/theme';

const { spacing, colors } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
	},
	stagesContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 800,
	},
	withPreProcess: {
		marginLeft: 216, // Pre-process card width (200px) + gap (16px) to align connectors with main cards
	},
	stageContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	status: {
		position: 'relative',
		width: 24,
		height: 24,
		borderRadius: '50%',
		':before': {
			content: '""',
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
			width: 8,
			height: 8,
			borderRadius: '50%',
		},
	},
	completed: {
		backgroundColor: colors.background.dark,
		border: `2px solid ${colors.background.dark}`,
	},
	inProgress: {
		backgroundColor: '#E3F2FD',
		':before': {
			backgroundColor: '#2196F3',
		},
	},
	notStarted: {
		backgroundColor: colors.background.light,
		border: `2px solid ${colors.background.dark}`,
	},
	idle: {
		backgroundColor: 'transparent',
		border: `2px solid ${colors.border.light}`,
		':before': {
			backgroundColor: colors.border.light,
		},
	},
	idleWithError: {
		backgroundColor: 'transparent',
		border: `2px solid ${colors.danger.main}`,
		':before': {
			backgroundColor: colors.danger.main,
		},
	},
	suspended: {
		backgroundColor: '#E0E0E0',
		':before': {
			backgroundColor: colors.background.light,
		},
	},
	suspendedWithError: {
		backgroundColor: colors.danger.main,
		':before': {
			backgroundColor: colors.background.light,
		},
	},
	connectorContainer: {
		flex: 1,
		padding: `0 ${spacing.sm}px`,
	},
	connector: {
		height: 2,
		width: '100%',
	},
	solidLine: {
		backgroundColor: colors.background.dark,
	},
	dashedLine: {
		background: `linear-gradient(to right, ${colors.primary.main} 50%, transparent 50%)`,
		backgroundSize: `${spacing.sm}px 2px`,
	},
	dashedRedLine: {
		background: `linear-gradient(to right, ${colors.danger.main} 50%, transparent 50%)`,
		backgroundSize: `${spacing.sm}px 2px`,
	},
	substepRow: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		height: 'min-content',
	},
	substepConnector: {
		height: 8,
		width: 8,
		borderLeft: `2px solid ${colors.border.light}`,
		borderBottom: `2px solid ${colors.border.light}`,
		marginLeft: spacing.sm,
		marginTop: spacing.xs,
	},
	substepConnectorContainer: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
	},
	substepStatusIndicator: {
		width: 8,
		height: 8,
		borderRadius: '50%',
		backgroundColor: colors.border.light,
		marginTop: spacing.sm + spacing.xs,
	},
	substepStatusActive: {
		backgroundColor: colors.primary.main,
	},
});
